// Initial state
const state = {
  // Reference to the database once loaded
  db: null
};

// getters
const getters = {
  db: (state) => () => {
    return state.db;
  }
};

// actions
const actions = {
};

// mutations
const mutations = {
  setDb (state, db) {
    state.db = db;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
